import { Button, Divider, Radio, Row, Space } from 'antd';
import { useCallback, useContext, useMemo } from 'react';

import { useWindowSize } from '@app/hooks';
import {
  CHF_HAS_RECORDS,
  CHF_VISITS_FILTER,
} from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';

import { hideFilterBlock } from '@pages/Clients/ClientsList/utils';

import type { RadioChangeEvent } from 'antd';

export const VisitsRecordsExistenceChild = ({
  filterGroupIndex,
}: {
  specificFilterId: string;
  filterGroupIndex: number;
}) => {
  const {
    filters,
    setUpServerDataChunk,
    handleDisabling,
    onChangeFiltersHandler,
  } = useContext(ClientFiltersContext);
  const { innerWidth } = useWindowSize();

  const recordsExistenceValue = useMemo(() => {
    const hasRecords =
      filters.VisitsFilter?.[filterGroupIndex]?.Values?.[0]?.HasRecords;
    return hasRecords === null ? null : hasRecords ? 1 : 2;
  }, [filters, filterGroupIndex]);

  const handleRecordsExistingChange = useCallback(
    (event: RadioChangeEvent, filterGroupIndex: number) => {
      const { target } = event;
      const { value } = target;
      const HasRecords = value === 1;

      onChangeFiltersHandler(
        'VisitsFilter',
        filterGroupIndex,
        'HasRecords',
        HasRecords
      );
    },
    [onChangeFiltersHandler]
  );

  return (
    <div
      className="VisitsRecordsExistenceChild"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Radio.Group
        value={recordsExistenceValue}
        onChange={(event) => {
          handleRecordsExistingChange(event, filterGroupIndex);
        }}
      >
        <Space direction="vertical">
          <Radio value={1}>Есть записи</Radio>
          <Radio value={2}>Нет записей</Radio>
        </Space>
      </Radio.Group>
      <Divider style={{ marginTop: '8px', marginBottom: '12px' }} />
      <Row justify="end">
        <Button
          type="primary"
          size="small"
          disabled={handleDisabling(
            CHF_VISITS_FILTER,
            CHF_HAS_RECORDS,
            false,
            '',
            filterGroupIndex
          )}
          onClick={() => {
            setUpServerDataChunk(
              CHF_VISITS_FILTER,
              CHF_HAS_RECORDS,
              false,
              '',
              filterGroupIndex
            );

            hideFilterBlock(
              '.visits-records-existence-label',
              innerWidth,
              filterGroupIndex
            );
          }}
        >
          Выбрать
        </Button>
      </Row>
    </div>
  );
};
